@if (!dataProtectionOfficer) {
  <div class="alert alert-secondary">
    Sie befinden sich gerade im Testsystem. Daher hat dieser Antrag keine Gültigkeit.
  </div>
} @else if ((form && (!form.visible || form.approvalDataProtectionOfficer !== 'APPROVED')) || process?.test) {
  <div class="alert alert-secondary">
    Dieses Formular befindet sich im Teststatus. Daher hat dieser Antrag keine Gültigkeit. Sie können das aktuelle produktive Formular über folgenden Link aufrufen, falls es verfügbar ist: <a href="{{webUrl}}/tag/{{form?.tag}}">{{webUrl}}/tag/{{form?.tag}}</a>
  </div>
}
@if (process) {
  @if (process.canceled) {
    <div class="alert alert-danger">
      <i class="fa-solid fa-circle-info"></i> Der Antrag wurde storniert.
    </div>
  }
  <div class="row position-relative">
    <div class="col-6 fw-bold h5 mb-2">
      Antragsteller
      <hr class="m-0 p-0">
    </div>
    <div class="col-6 fw-bold h5 mb-2">
      <div class="hr">Status</div>
      <hr class="m-0 p-0">
    </div>
    <div class="col-6">
      <p class="mb-0">{{process.firstName}} {{process.lastName}}</p>
      @if (process.emailAddress) {
        <p class="small mb-0">Benutzername: {{process.username}}</p>
        <p class="small mb-0">E-Mail-Adresse: {{process.emailAddress}}&ensp;<i class="d-inline-block pointer fa-regular fa-copy" [rbbCopyTooltip]="process.emailAddress"></i></p>
      }
    </div>
    <div class="col-6">
      <div class="col-12 fw-bold">
        @switch (process.status) {
          @case (ProcessStatus.DRAFT) {
            <span class="text-secondary">Entwurf @if (process.changedByOther) {von {{process.changedByOther}}}</span>
          }
          @case (ProcessStatus.SENT) {
            <span class="text-secondary">Der Antrag befindet sich in der Genehmigung.</span>
          }
          @case (ProcessStatus.DECLINED) {
            <span class="text-danger">Der Antrag wurde abgelehnt.</span>
          }
          @case (ProcessStatus.CANCELED) {
            <span class="text-danger">Der Antrag wurde vom Antragssteller storniert.</span>
          }
          @case (ProcessStatus.APPROVED) {
            <span class="text-secondary">
              Der Antrag
              @if (process.approvals?.length) {
                wurde genehmigt
              } @else {
                braucht keine Genehmigung
              }
              und wird demnächst bearbeitet.
            </span>
          }
          @case (ProcessStatus.CANCELED_AFTER_APPROVED) {
            <span class="text-danger">
              Der Antrag wurde vom Antragssteller @if (process.approvals?.length) {nach der Genehmigung} storniert.
            </span>
          }
          @case (ProcessStatus.IN_PROGRESS) {
            <span class="text-secondary">Der Antrag wird bearbeitet.</span>
          }
          @case (ProcessStatus.FINISHED) {
            <span class="text-success">Der Antrag wurde von der Fachabteilung bearbeitet.</span>
          }
          @case (ProcessStatus.REJECTED) {
            <span class="text-danger">Die Bearbeitung des Antrags wurde von der Fachabteilung zurückgewiesen.</span>
          }
          @case (ProcessStatus.TRANSMITTED) {
            <span class="text-success">Der Antrag wurde an die Fachabteilung übermittelt.</span>
          }
          @case (ProcessStatus.TRANSMISSION_FAILED) {
            <span class="text-danger">Die Übermittlung des Antrags an die Fachabteilung ist fehlgeschlagen. Bitte stellen Sie den Antrag erneut. Falls das Problem weiterhin auftritt, melden Sie sich bitte beim Support.</span>
          }
          @case (ProcessStatus.OLD) {
            <span class="text-danger">Der Entwurf für den Antrag ist veraltet und muss neu ausgefüllt werden.</span>
          }
          @case (ProcessStatus.UNKNOWN) {
            <span class="text-secondary">Der Bearbeitungsstatus ist unbekannt.</span>
          }
        }
      </div>
      @if (process.timestamp) {
        <div class="col-12 text-secondary">
          @if (process.number) {
            <div>Antragsnummer: {{process.number}}</div>
          }
          <div>Erstellt am: {{process.timestamp | date:'dd.MM.yyyy HH:mm'}}</div>
          @if (approved) {
            <div>Genehmigt am: {{approved | date:'dd.MM.yyyy HH:mm'}}</div>
          }
          @if (declined) {
            <div>Abgelehnt am: {{declined | date:'dd.MM.yyyy HH:mm'}}</div>
          }
          @if (process.canceled) {
            <div>Storniert am: {{process.canceled | date:'dd.MM.yyyy HH:mm'}}</div>
          }
          @if (process.inProgress) {
            <div>Bearbeitung gestartet am: {{process.inProgress | date:'dd.MM.yyyy HH:mm'}}</div>
            @if (process.preProgressComment) {
              <div class="fw-bold small">Kommentar: {{process.preProgressComment}}</div>
            }
          }
          @if (process.finished) {
            <div>Bearbeitung {{ process.status === ProcessStatus.REJECTED ? 'zurückgewiesen' : 'abgeschlossen'}} am: {{process.finished | date:'dd.MM.yyyy HH:mm'}}</div>
          }
          @if (process.lastOperator) {
            <div class="fw-bold small">Bearbeiter/in: {{process.lastOperator}}</div>
          }
          @if (process.finished && process.progressComment) {
            <div class="fw-bold small">Kommentar: {{process.progressComment}}</div>
          }
          @if (process.transmitted) {
            <div>Übermittelt am: {{process.transmitted | date:'dd.MM.yyyy HH:mm'}}</div>
            @if (process.preProgressComment) {
              <div class="fw-bold small" [innerHtml]="utilService.prepareLink('Übermittlungshinweis: ' + process.preProgressComment)"></div>
            }
          }
          @if (process.resubmitted) {
            <div class="fw-bold small">Die Fachabteilung wird die Bearbeitung des Antrags am {{process.resubmitted | date:'dd.MM.yyyy'}} beginnen/fortsetzen.</div>
          }
          @if (process.attachments?.length) {
            <div class="text-body">Anhänge:
              <ul>
                @for (attachment of process.attachments; track attachment.id) {
                  <li>
                    @if (attachment.deleted) {
                      <span class="d-inline-block text-decoration-line-through">{{attachment.fileName}}</span>({{attachment.timestamp | date:'dd.MM.yyyy HH:mm'}}, gelöscht durch Systemadministratoren am {{attachment.deleted | date:'dd.MM.yyyy HH:mm'}})
                    } @else {
                      <a (click)="openAttachment(attachment.id)" (keydown.enter)="openAttachment(attachment.id)" (keydown.space)="openAttachment(attachment.id)" tabindex="0" class="pointer h-underline">{{attachment.fileName}} ({{attachment.timestamp | date:'dd.MM.yyyy HH:mm'}})</a>
                      @if (employee()?.admin) {
                        <button [rbbButtonConfirmType]="ButtonConfirmType.ChangeText" rbbButtonConfirmContent="Wirklich löschen?" [rbbButtonConfirmStaticWidth]="true" (rbbButtonConfirmOnConfirmed)="deleteAttachment(attachment)" class="btn btn-sm btn-danger">Löschen</button>
                      }
                    }
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      }
    </div>

    @if (form?.approverTypes?.length || process.approvals?.length) {
      <div class="col-12 fw-bold h5 mb-2 mt-3">
        Genehmigungsweg
        <hr class="m-0 p-0">
      </div>
      @if (employee()) {
        <div class="col-12">
          @if (validOrgUnits && process.status === ProcessStatus.DRAFT) {
            <div class="row mb-3">
              <div class="col-12">
                <label class="d-block small text-darkgray fw-bold">Wählen Sie die Organisationseinheit aus, die für die Berechnung des Genehmigungswegs genutzt werden soll:</label>
                <select class="form-select form-select-sm" id="validOrgUnits" [(ngModel)]="selectedValidOrgUnit" (ngModelChange)="setOrgUnitAsActive($event)">
                  @for (validOrgUnit of validOrgUnits; track validOrgUnit.id) {
                    <option [ngValue]="validOrgUnit">{{validOrgUnit.orgUnit}} / {{validOrgUnit.costCentre}} @if (validOrgUnit.sap) {(SAP)}</option>
                  }
                </select>
                <span class="d-block small text-secondary mt-1"><i class="fas fa-info pe-1"></i>&ensp;Sie können neue Organisationseinheiten und Kostenstellen unter <a routerLink="/my-data">"Meine Daten"</a> hinzufügen.</span>
                @if (changingActiveOrgUnit || loadingEmployee()) {
                  <span class="d-block small text-primary">Aktualisiere Daten...</span>
                }
              </div>
            </div>
          }
          @if (!process.approvals?.length && process.status === ProcessStatus.DRAFT) {
            Der Genehmigungsweg wird beim Bearbeiten des Antrags ermittelt.
          }
          @for (approval of (process.approvals ?? []); track approval.id; let i = $index) {
            <div class="row mb-2">
              <div class="col-12 text-secondary fw-bold">
                {{i + 1}}.
                @switch (true) {
                  @case (approval.approverType === ApproverType.CHIEF || approval.approverType === ApproverType.CHIEF_AND_DEPUTY) {
                    Vorgesetzte/r
                  }
                  @case (approval.approverType === ApproverType.COST_CENTRE_RESPONSIBLE || approval.approverType === ApproverType.COST_CENTRE_RESPONSIBLE_AND_DEPUTY) {
                    Kostenstellenverantwortliche/r
                  }
                  @case (approval.approverType === ApproverType.DEPARTMENT_CHIEF || approval.approverType === ApproverType.DEPARTMENT_CHIEF_AND_DEPUTY) {
                    Abteilungsleiter/in
                  }
                  @case (approval.approverType === ApproverType.MAIN_DEPARTMENT_CHIEF || approval.approverType === ApproverType.MAIN_DEPARTMENT_CHIEF_AND_DEPUTY) {
                    HA Leiter/in
                  }
                  @case (approval.approverType === ApproverType.DIRECTOR || approval.approverType === ApproverType.DIRECTOR_AND_DEPUTY) {
                    Direktor/in
                  }
                  @case (approval.approverType === ApproverType.DESIGNATED_APPROVER) {
                    Festgelegte/r Genehmiger/in
                  }
                  @case (approval.approverType === ApproverType.APPROVER_GROUP) {
                    Festgelegte Genehmigergruppe
                  }
                  @case (approval.approverType === ApproverType.SELECTED_APPROVER) {
                    Ausgewählte/r Genehmiger/in
                  }
                }
              </div>
              <div class="col-6">
                @if (approval.groupMemberSize) {
                  <span class="mx-3"><i class="fa-solid fa-user-group"></i> Eine Fachgruppe bestehend aus {{approval.groupMemberSize}} Genehmigern</span>
                }
                @if (approval.username && approval.approverType !== ApproverType.APPROVER_GROUP) {
                  <i class="mx-3 d-inline-block fas fa-user-tie"></i>{{approval.firstName}} {{approval.lastName}}
                }
                @if (approval.deputyUsername) {
                  <div><i class="fas fa-user-tie d-inline-block mx-3"></i>{{approval.deputyFirstName}}
                    {{approval.deputyLastName}}<span class="text-secondary"><i>(Stellvertretung)</i></span></div>
                }
                @if ((approval.approverType === ApproverType.COST_CENTRE_RESPONSIBLE || approval.approverType === ApproverType.COST_CENTRE_RESPONSIBLE_AND_DEPUTY) && !approval.username) {
                  <div class="small text-secondary mx-3 description-badge"><i class="fas fa-info"></i>&ensp;Der/Die Kostenstellenverantwortliche kann noch nicht angezeigt werden.</div>
                }
                @if (approval.approverType === ApproverType.SELECTED_APPROVER && !approval.username) {
                  <span class="small text-secondary d-block mx-3 description-badge"><i class="fas fa-info"></i>&ensp;Der/Die Genehmiger/in kann noch nicht angezeigt werden.</span>
                }
              </div>
                <div class="col-6">
                  @switch (approval.approved) {
                    @case (Approved.APPROVED) {
                      <div class="fw-bold text-success">
                        <i class="fas fa-check" aria-hidden="true"></i>&ensp;{{ approval.forInformationOnly ? 'Zur Kenntnis genommen' : 'Genehmigt' }}
                        @if (approval.approvedBy === approval.deputyUsername) {
                          durch Stellvertretung
                        }
                        @if (approval.approverType === ApproverType.APPROVER_GROUP) {
                          durch {{approval.firstName}} {{approval.lastName}}
                        }
                        @if (approval.approvedAt) {
                          ({{approval.approvedAt | date:'dd.MM.yyyy HH:mm'}})
                        }
                      </div>
                    }
                    @case (Approved.PENDING) {
                      @if (process.status === ProcessStatus.SENT && (approval.orderNumber === 0 || getPreviousApproval(i)?.approved === Approved.APPROVED)) {
                        <div class="fw-bold text-secondary">
                          <i class="fas fa-hourglass-end" aria-hidden="true"></i>&ensp;In Bearbeitung
                        </div>
                      }
                    }
                    @case (Approved.DECLINED) {
                      <div class="fw-bold text-danger">
                        <i class="fas fa-times" aria-hidden="true"></i>&ensp;Abgelehnt
                        @if (approval.approvedBy === approval.deputyUsername) {
                          durch Stellvertretung
                        }
                        @if (approval.approverType === ApproverType.APPROVER_GROUP) {
                          durch {{approval.firstName}} {{approval.lastName}}
                        }
                        @if (approval.approvedAt) {
                          ({{approval.approvedAt | date:'dd.MM.yyyy HH:mm'}})
                        }
                      </div>
                    }
                  }
                  @if (approval.approvalComment) {
                    <span class="text-secondary small">Kommentar: {{approval.approvalComment}}</span>
                  }
                  @if (approval.limitTimestamp && approval.approved === Approved.PENDING && process.status === ProcessStatus.SENT && (approval.orderNumber === 0 || getPreviousApproval(i)?.approved === Approved.APPROVED)) {
                    <span class="text-secondary small">Automatische Genehmigung am {{approval.limitTimestamp | date:'dd.MM.yyyy'}}</span>
                  }
                </div>
            </div>
          }
          @if (process.status === ProcessStatus.DRAFT && process.approvals?.length) {
            <span class="small text-secondary d-block mb-3 description-badge mt-4">
              <i class="fas fa-info"></i>&ensp;Bitte überprüfen Sie den ermittelten Genehmigungsweg. Falls die zu genehmigenden Führungskräfte nicht korrekt ermittelt wurden, wenden Sie sich bitte <a href="mailto:stellenplan@rbb-online.de">stellenplan&commat;rbb-online.de</a>.
            </span>
          }
        </div>
      }
    }
    @if (!approvalsValid()) {
      <div class="h-100 w-100" style="position: absolute; background-color: #0006; top: 0; left: 0; z-index: 1000;"></div>
    }
  </div>
}
